const STRUCT = {
  ID: 'id',
  NAME: 'title',
};

export default STRUCT;
